import { createSelector } from 'reselect';

const selectmenucategory = state => state.menuCategory;

export const selectMenuCategory = createSelector(
    [selectmenucategory],
    (category) => category.menuCategory
)
export const selectMenuCategoryLoading = createSelector(
    [selectmenucategory],
    (category) => category.isfetching
)